<template>
  <div id="attribution">
    <div class="cuebiq-panel" v-for="(row, index) in summary_insights" :key="index">
      <div class="cuebiq-panel__heading">
        <h3 class="cuebiq-panel__title">{{ row.title }}</h3>
      </div>
      <div class="cuebiq-panel__body">
        <div class="row">
          <div class="col-xs-4" v-for="(stats, index) in row.row" :key="index" v-if="stats.data">
            <div class="metric">
              <div class="metric__icon-container">
                <img class="metric__icon-image" :src="imgBasePath + stats.img" alt="">
              </div>
              <div class="metric__content">
                <h3 class="metric__title">{{ stats.format ? stats.format(stats.data): stats.data }}</h3>
                <p class="metric__subtitle">{{ stats.label }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/modules/utils';

export default {
    name: 'summary-insights',
    data: function() {
      return {
        imgBasePath: this.$chartSettings['image_path'] + "attribution/insights/ico-",
        summary_insights: []
      }
    },
    beforeRouteLeave(to, from, next) {
      this.$splashScreen.tabEnabled = true;
      next();
    },
    mounted: function() {
      this.$splashScreen.tabEnabled = false;
      this.$cursorSpinner.processing = false;
      this.$nextTick(() => {
        this.fetchData();
        this.$_am.logEvent("visit",this.$route.name,"summary-insights",new Date().toISOString())
      });
    },
    methods: {
      fetchData: function () {
        var self = this;

        self.$dataStore.json( "insight_conclusions.json", function( data ) {
          self.formatData(data);
          self.$reportSettings.setVisibility();
        });
      },
      formatData: function(jsonData) {
        var self = this;
        self.summary_insights.push({
          title: "Performance Stats",
          row: self.getPerfRow(jsonData)
        },{
          title: "Time & Day Stats",
          row: self.getTimeRow(jsonData)
        },{
          title: "Geo Stats",
          row: self.getGeoRow(jsonData)
        },{
          title: "Insights",
          row: self.getInsightsRow(jsonData)
        })
      },
      getPerfRow: function(jsonData) {
        return [
          {
            format: function(d) { return d3.format('.2%')(d);},
            label: "Uplift",
            data: jsonData.uplift,
            img: "uplift.png"
          },
          {
            label: jsonData.projectedVisitsLabel ? jsonData.projectedVisitsLabel: "Total number of visits",
            data: jsonData.numberOfVisits,
            img: "visits.png"
          },
          {
            format: function(d) { return d3.format('.2%')(d);},
            label: "Match Rate",
            data: jsonData.matchRate,
            img: "match-rate.png"
          },
          {
            format: function(d) { return d3.format('.2%')(d);},
            label: "Visit Rate",
            data: jsonData.visitRate,
            img: "visit-rate.png"
          },
          {
            format: function(d) { return '$' + d3.format('.2f')(d);},
            label: "Cost per incremental visit",
            data: jsonData.costPerVisit,
            img: "visit-cost.png"
          }
        ]
      },
      getTimeRow: function(jsonData) {
        return [
          {
            format: function(d) { return d3.format('.0%')(d.ratio) + " of users spent " + d.timeBucketBean.min + "-" + d.timeBucketBean.max + " min in store";},
            label: "Most common dwell time",
            data: jsonData.timeMaxBucket,
            img: "max-bucket.png"
          },
          {
            format: function(d) { return d3.format('.0%')(d.ratio) + " of users converted in " + d.date;},
            label: "Time to convert",
            data: jsonData.conversionMaxBucket,
            img: "conversion-max-bucket.png"
          },
          {
            format: function(d) { return utils.format.colonFormatter(utils.format.dateFormatter(d.date), d3.format('.2%')(d.visitRate) + " visit rate");},
            label: "Best day",
            data: jsonData.bestDayOfVisits,
            img: "best-day.png"
          }
        ]
      },
      getGeoRow: function(jsonData) {
        return [
          {
            label: "Total Number of Served GEOs",
            data: jsonData.numberOfReachedDistricts,
            img: "districts-reached.png"
          },
          {
            format: function(d) { return utils.format.colonFormatter(d.name, utils.format.nFormatter(d.count, 1) + " impressions");},
            label: "Top served GEOs",
            data: jsonData.mostReachedDistrict,
            img: "districts-top.png"
          },
          {
            label: "Total POIs",
            data: jsonData.poisCount,
            img: "pois.png"
          }
        ]
      },
      getInsightsRow: function(jsonData) {
        return [
          {
            label: "Top Reached Carriers",
            data: jsonData.topReachedCarriers,
            img: "top-carries.png"
          },
          {
            format: function(d) { return utils.format.colonFormatter(d.level2 , d3.format('.2%')(d.uplift));},
            label: "Audience Segment with Highest Uplift",
            data: jsonData.behaviorMax,
            img: "top-geo-segment.png"
          }
        ]
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tabs/SummaryInsights.vue